module.exports = new __parcel__URL__("battery-charging.ba1b1745.webp").toString();